import {Box, Typography} from '@mui/material';
import {MessageCircle} from 'lucide-react';
import React from 'react';
import {useBrandTheme} from '../useBrandTheme';

interface ChatiwinLogoProps {
  variant: `light` | `dark`;
}

export const ChatiwinLogo: React.FC<ChatiwinLogoProps> = ({variant}) => {
  const theme = useBrandTheme();

  const isLight = variant === `light`;

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        gap: 1,
        userSelect: `none`,
      }}
    >
      <MessageCircle
        size={20}
        style={{
          color: isLight ? theme.custom.colors.ui.white : theme.custom.colors.primary,
          fill: isLight ? theme.custom.colors.ui.white : theme.custom.colors.primary,
        }}
      />
      <Typography
        sx={{
          fontSize: `20px`,
          fontWeight: 700,
          ...(isLight
            ? {
                color: theme.custom.colors.ui.white,
                textShadow: `0 1px 3px rgba(0, 0, 0, 0.3)`,
              }
            : {
                background: `linear-gradient(135deg, ${theme.custom.colors.primary} 0%, ${theme.custom.colors.secondary} 50%, ${theme.custom.colors.accent} 100%)`,
                WebkitBackgroundClip: `text`,
                WebkitTextFillColor: `transparent`,
                backgroundClip: `text`,
              }),
          fontFamily: `"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
          letterSpacing: `-0.5px`,
        }}
      >
        chatiwin
      </Typography>
    </Box>
  );
};
